import { GTDDomainError } from '../../../project-management/domain/errors/GTDDomainError';

/**
 * InboxContent Value Object
 * 
 * Enforces GTD capture rules:
 * - Content cannot be empty (must capture something meaningful)
 * - Minimum 3 characters to prevent accidental captures
 * - Maximum 5000 characters to maintain focus on quick capture
 * 
 * Fixes data corruption by ensuring all content is validated at domain level.
 */
export class InboxContent {
    private constructor(private readonly _value: string) {
        if (!_value || _value.trim().length === 0) {
            throw new GTDDomainError(
                'Inbox content cannot be empty',
                'EMPTY_INBOX_CONTENT'
            );
        }
        if (_value.trim().length < 3) {
            throw new GTDDomainError(
                'Inbox content must be at least 3 characters',
                'INBOX_CONTENT_TOO_SHORT',
                { minLength: 3, actualLength: _value.trim().length }
            );
        }
        if (_value.length > 5000) {
            throw new GTDDomainError(
                'Inbox content cannot exceed 5000 characters',
                'INBOX_CONTENT_TOO_LONG',
                { maxLength: 5000, actualLength: _value.length }
            );
        }
    }
    
    static create(content: string): InboxContent {
        return new InboxContent(content?.trim());
    }
    
    get value(): string { 
        return this._value; 
    }
}